module.exports = __webpack_public_path__ + "img/down68.75f53cbf.png";